<template>
  <div id="app">
    <Spin size="large" fix v-if="spinShow"></Spin>
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    organ_id() {
      return this.$store.state.user.organ_id
    },
    spin() {
      return this.$store.state.app.spinShow
    },
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
      spinShow: false,
    }
  },
  created() {},
  mounted() {},
  methods: {
    reload() {
      this.isRouterAlive = false //先关闭，
      this.spinShow = true
      this.$nextTick(function () {
        this.isRouterAlive = true //再打开
      })
    },
    spin_show() {
      var time = setInterval(() => {
        if (this.$store.state.app.spinShow == false) {
          setTimeout(() => {
            this.spinShow = this.$store.state.app.spinShow
            clearTimeout(time)
          }, 300)
        }
      }, 100)
    },
  },
  watch: {
    organ_id(val) {
      this.spin_show()
      this.reload()
    },
  },
}
</script>
 
<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue